import { acceptHMRUpdate, defineStore } from 'pinia'
import { ref } from 'vue'
import {
  closeAssistantChat as closePackageAssistantChat,
  openAssistantChat as openPackageAssistantChat
} from '@cplug/assistant-chat'

/**
 * Estado do shell (lateral) do assistente no ERP.
 * Fonte de verdade para abrir/fechar a UI — evita depender só da store
 * interna do @cplug/assistant-chat (risco de instâncias duplicadas no bundle).
 */
const useAssistantShellStore = defineStore('shared/assistant-shell', () => {
  const isOpen = ref(false)

  function open (): void {
    isOpen.value = true
    openPackageAssistantChat()
  }

  function close (): void {
    isOpen.value = false
    closePackageAssistantChat()
  }

  function toggle (): void {
    if (isOpen.value) {
      close()
      return
    }
    open()
  }

  return {
    isOpen,
    open,
    close,
    toggle
  }
})

export default useAssistantShellStore

/* c8 ignore next 3 */
if ((import.meta as any).hot) {
  (import.meta as any).hot.accept(acceptHMRUpdate(useAssistantShellStore, (import.meta as any).hot))
}
